import Vue from 'vue';
import accountTransformer from './../../transformers/account';
import find from './find';

// When the request succeeds
const success = (resolve) => {
  find();
  resolve();
};

// When the request fails
const failed = (error, reject) => {
  reject(accountTransformer.fetch(error.response.data));
};

/* eslint no-console: ["error", { allow: ["log"] }] */
export default (account) => {
  const p = new Promise((resolve, reject) => {
    Vue.$http.put('/account/user', account)
    .then(() => {
      success(resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  });
  return p;
};



// WEBPACK FOOTER //
// ./src/app/services/account/updateUser.js